import script from "./UploadsAudioTab.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadsAudioTab.vue?vue&type=script&setup=true&lang=js"

import "./UploadsAudioTab.vue?vue&type=style&index=0&id=03aa526e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03aa526e"]])

export default __exports__